/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { Image } from 'react-bootstrap'
import { mobileComputer, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DesktopBannerPreview({ srcs, redirectUrl }) {
  const BackgroundImg = srcs.find((s) => s.label === 'Background img')

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') return file
    return ''
  }

  return (
    <div
      className="scroller-hide"
      style={{
        maxHeight: '30.5vh',
        width: '100%',
        overflow: 'auto',
        marginTop: '20%',
      }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobileComputer}
          style={{ width: '38rem', right: '3%', bottom: '25%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '100%', height: '55px', zIndex: '0' }}
          >
            <div className="w-90 m-auto ms-auto">
              <Image
                src={wavenet_logo}
                style={{ height: '45px' }}
                className="ps-3"
              />
            </div>
            <div className="w-10 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="text-end" />
            </div>
          </div>
          {BackgroundImg?.file && (
            <button
              type="button"
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
              style={{
                border: 'none',
                padding: '0',
                cursor: 'pointer',
                position: 'relative',
                background: 'transparent',
              }}
            >
              <img
                className="position-relative px-3 pb-2"
                src={getPreviewURL(BackgroundImg.file)}
                alt="Background"
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: 'auto',
                  left: 0,
                  bottom: 0,
                  zIndex: 2,
                }}
              />
              <CIIcon bottom="7%" right="3.5%" />
            </button>
          )}
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>
    </div>
  )
}

DesktopBannerPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

DesktopBannerPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default DesktopBannerPreview
